import { useEffect, useState } from 'react'
import { Form } from 'antd'

import { SL_Input } from '../../../../components/input/Input'
import { FormItem } from '../../components/FormItem'
import { ManageCentrals } from '../../components/ManageCentrals'
import { FormSubtitle } from '../../components/FormSubtitle'

import { displayMessage } from '../../../../helpers/messages'
import api from '../../../../services/api'

import '../../gradients.css'

export const NewGroup = ({ sendValues, form, onlyView, isAdding, setShowLoading }) => {
    const [dataToManage, setDataToManage] = useState(null)

    const manageCentrals = async () => {
        setShowLoading(true)
        try {
            const { data } = await api.groups.prevDataToManageCentrals(null)
            setDataToManage(data)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    useEffect(() => {
        if (isAdding) manageCentrals()
    }, [isAdding])
    return (
        <Form disabled={onlyView} onFinish={sendValues} className="w-full flex flex-col settings-modal-configs-form-divisions" layout="vertical" requiredMark={false} form={form}>
            <div className="flex flex-col settings-modal-configs-form">
                <FormSubtitle message={displayMessage('IDENTIFICATION')} />

                <FormItem className={'flex flex-col w-full'} name="name" label={displayMessage('FIRST_NAME')}>
                    <SL_Input placeholder={displayMessage('FIRST_NAME')} className={'w-full font-bold shadow-md bg-black settings-modal--input text-white'} />
                </FormItem>
            </div>

            {isAdding && dataToManage && <ManageCentrals data={dataToManage} form={form} onManageCentrals={(e) => sendValues(e)} isAdding={true} />}
        </Form>
    )
}
